import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import "moment/locale/de";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import {
    CloseIcon,
    DeleteIcon,
    CalendarIcon,
    TimeIcon,
    KommissionIcon,
    PhoneIcon,
    AttachmentIcon,
    PersonIcon,
    WorkIcon,
    ProjectIcon,
} from "../../bundles/IconsBundle";
import convertFile from "../extensions/FileConverter";
import TakePhoto from "../extensions/TakePhoto";
import MessageBox from "../dialogs/MessageBox";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { Scrollbars } from 'react-custom-scrollbars';

import { setTitle } from "../../actions/AppActions";
import {
    SelectAppointmentByID,
    SetPropertyValue,
    SavePropertyValue,
    SaveData,
    FotoAdd,
    FotoRemove
} from "../../actions/TaskActions";
import {
    SelectedAppSelector,
    SelectedAppAttachmentsSelector,
    SelectedAppNotesSelector,
    SelectedAppPhotosSelector
} from "../../selectors/SelectedAppointmentSelector";
import StartWorkQuestionDialog from "../dialogs/menck/StartWorkQuestionDialog";

const styles = {
    container: {
        textAlign: "left",
        marginTop: "75px",
        marginLeft: "20px",
        marginRight: "20px",
    },
    notiz: {
        wordBreak: 'break-all',
       marginRight: '15px',
    },
    tablecell: {
        paddingRight: '15px'
    }
};

class TaskUnassigned extends Component {
    state = {
        dialog: false,
        TakePhotoOpen: false,
        images: this.props.images || [],
        _deleteImageId: -1,
        _deleteImageMessageOpen: false,
        questionDialogOpen: false,
        questionFinishDialogOpen: false,
        dialogApp: {},
        dialogImages: [],
        selectDateTimeDialogOpen: false,
        type: 1
    };

    file_input = [];

    componentDidMount() {
        moment.locale("de");
        this.props.setTitle("Unverteilte Vorgänge");
        this.props.SelectAppointmentByID(this.props.match.params.id,this.props.match.params.service);

        console.log("mounted task-view", this.props.match.params.id);
    }

    _returnDescriptionData = data => {
         return JSON.parse(data !== undefined && data !== "" ? data.toString() : "[]");
    };

    materialTypeToName = item => {
        var material = "";
        if (item.MaterialType === 0) material = "PVC_Fenster";
        if (item.MaterialType === 1) material = "PVC_Hausturen";
        if (item.MaterialType === 2) material = "Rolladen";
        if (item.MaterialType === 3) material = "ALU_Hausturen";
        if (item.MaterialType === 4) material = "ALU_Fenster";
        if (item.MaterialType === 5) material = "HST";
        return material;
    };

    renderTrackHorizontal = () => {
        return false;
    }

    handleClose = () => {
        this.props.history.goBack();
    };

    disableCheckBox = (item) => {
        if (item === 0) return false;
        else return true;
    }

    fotoMachen = () => {
        this.setState({ TakePhotoOpen: true, images: this.state.images });
    };

    closeTakePhoto = () => {
        this.setState({ TakePhotoOpen: false });
    };

    handleTakeScreenshot = src => {
        this.props.FotoAdd(this.props.app, src);
        var st = this.state;
        //st.images.push(src);
        st.TakePhotoOpen = false;
        this.setState(st);
    };

    removeImage = idToRemove => {
        var st = this.state;
        st._deleteImageId = idToRemove;
        st._deleteImageMessageOpen = true;
        this.setState(st);
    };

    onRemoveImage = () => {
        var st = this.state;
        //st.images = this.state.images.filter((item,index) => index !== this.state._deleteImageId)
        this.props.FotoRemove(st._deleteImageId);
        st._deleteImageId = -1;
        st._deleteImageMessageOpen = false;
        this.setState(st);
    };

    handleCloseMessage = () => {
        var st = this.state;
        st._deleteImageMessageOpen = false;
        this.setState(st);
    };

    openDocument = att => {
        convertFile(att.FileName, att.Extension, att.Attachment);
    };

    ShowPDF = att => {
        convertFile("Bericht", ".pdf", att);
    };

    materialUndZeit = () => {
        this.props.history.push(
            "/material/" + this.props.match.params.id+ "/" + this.props.match.params.service + "/edit"
        );
        this.setState({ ...this.state, dialog: true });
    }

    signDialog = () => {
        this.props.history.push(
            "/tasksign/" + this.props.match.params.id + "/" + this.props.match.params.service + "/edit"
        );
        this.setState({ ...this.state, dialog: true });
    };

    saveDataMenck = async () => {
        const data = {
            Finished: this.props.app.Finished,
            StartTime: this.props.app.StartTime,
            Duration: this.props.app.Duration,
            ErledigteArbeiten: this.props.app.ErledigteArbeiten,
        };
        await this.props.SaveData(this.props.app, data);
    };

    ToggleWorkAsk = (app, name) => {
        this.setState({
            ...this.state,
            questionDialogOpen: true,
            dialogApp: app,
            type: name === "Start" ? 1 : 0
        });
    };

    handleCloseDialogs = () => {
        this.setState({
            ...this.state,
            questionDialogOpen: false,
            questionFinishDialogOpen: false,
            selectDateTimeDialogOpen: false,
            type: 1
        });
    };

    toggleWorkAccepted = async (e) => {
        let name = e.currentTarget.name;
        const dt = new Date();
        dt.setSeconds(0, 0);
        const app = this.state.dialogApp;
        if (name === "Start") {
            await this.props.SavePropertyValue(app, "Started", 1);
            this.props.SavePropertyValue(app, "StartTime", dt);

            await this.setState({
                ...this.state,
                dialogApp: null,
                questionDialogOpen: false
            });
        } else {
            await this.props.SavePropertyValue(app, "Finished", 1);

            const duration = moment.duration(
                moment(Date.now()).diff(moment(app.StartTime))
            );
            await this.props.SavePropertyValue(app, "Duration", Math.round(duration.asMinutes()));

            this.setState({
                ...this.state,
                dialogApp: null,
                questionDialogOpen: false
            });
        }
    };

    handleChange = async (e, checked) => {
        console.log(this.props.app.IDService);
        if (e._d) {
            await this.props.SavePropertyValue(
                this.props.app,
                "StartTime",
                e._d
            );
        } else {
            if (e.target.name === "Finished") {
                await this.props.SetPropertyValue(
                    this.props.app,
                    e.target.name,
                    checked ? 1 : 0
                );
                const duration = moment.duration(
                    moment(Date.now()).diff(moment(this.props.app.StartTime))
                );
                await this.props.SetPropertyValue(
                    this.props.app,
                    "Duration",
                    Math.round(duration.asMinutes())
                );
                this.SaveData();
            } else
                await this.props.SetPropertyValue(
                    this.props.app,
                    e.target.name,
                    e.target.value
                );
        }
    };

    handleBlur = async e => {
        this.SaveData();
    };

    selectFile = event => {
        event.preventDefault();
        console.log("FI", this.file_input);
        this.file_input = document.createElement("input");
        this.file_input.addEventListener(
            "change",
            this.uploadFile.bind(this),
            false
        );
        this.file_input.type = "file";
        this.file_input.click();
    };

    isDocumentUpdateNeeded = () => {
        const pdfData = this.props.app.pdfFieldValues;
        const appData = this.props.app;
        if (!pdfData) return false;
        if (pdfData.AdditionalServiceNeeded !== appData.AdditionalServiceNeeded)
            return true;
        if (pdfData.Finished !== appData.Finished) return true;
        if (pdfData.Duration !== appData.Duration) return true;
        if (pdfData.ErledigteArbeiten !== appData.ErledigteArbeiten)
            return true;
        if (pdfData.StartTime !== appData.StartTime) return true;
        if (pdfData.hasBild !== (this.props.fotos.length > 0)) return true;

        return false;
    };

    getBase64 = file => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    };

    uploadFile = () => {
        this.getBase64(this.file_input.files[0]).then(src =>
            this.props.FotoAdd(this.props.app, src)
        );
    };
    handleErledigtChange = (id, checked) => e  => {
        const ParsedData = JSON.parse(this.props.app.ServiceMangelbeschreibung);

        let ChangedDataString = ParsedData.map(d => {
            if (d.id === id) {
                d.Erledigt = checked;
                return d;
            } else return d;
        });
        ChangedDataString = JSON.stringify(ChangedDataString);
        this.props.SavePropertyValue(this.props.app,"ServiceMangelbeschreibung", ChangedDataString);

    };

    ShowAppointment = val => {
        this.props.history.push("/task/" + val.id);
    };

    startWorkAccepted = async (app) => {
        const dt = new Date();
        dt.setSeconds(0, 0);
        await this.props.SavePropertyValue(app, "Started", 1);
        await this.props.SavePropertyValue(app, "StartTime", dt);

        this.setState({
            ...this.state,
            dialogApp: null,
        });
    };

    render() {
        const { app, notes, fotos } = this.props;

        return (
            <Dialog fullScreen open={true}>
                <AppBar>
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            onClick={this.handleClose}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <div style={{ width: "50%" }}>
                            <div>
                                {app.ServiceNr} - {app.ekName}
                            </div>
                            <div>
                                ({app.ekPLZ} - {app.ekOrt})
                            </div>
                        </div>
                        <div style={{ width: "50%", textAlign: "right" }}>
                            {/* <Button
                                variant="contained"
                                size="medium"
                                id="fabFinish"
                                aria-label="Dest"
                                color="secondary"
                                name="StartTime"
                                onClick={() => {
                                    this.ToggleWorkAsk(app, "Start");
                                }}
                                disabled={
                                    app.Started === 1
                                }
                                style={{
                                    backgroundColor:
                                        app.Started === 1 || app.Finished === 1
                                            ? "gray"
                                            : "secondary",
                                    margin: "5px",
                                    color: "white",
                                    width: "90px"
                                }}
                            >
                                <WatchIcon size="small" />
                                Start
                            </Button>
                            <Button
                                variant="contained"
                                size="medium"
                                aria-label="Dest"
                                id="fabStart"
                                name="Finished"
                                color="secondary"
                                onClick={() => {
                                    this.ToggleWorkAsk(app, "End");
                                }}
                                disabled={
                                    app.Started !== 1 || app.Started === undefined || (
                                        app.Finished === 1 && app.EndDate !== null)
                                }
                                style={{
                                    backgroundColor:
                                        app.Started !== 1 || app.Finished === 1
                                            ? "gray"
                                            : "#b2232e",
                                    color: "white",
                                    width: "90px",
                                    margin: "5px"
                                }}
                            >
                                <WatchCheckedIcon size="small" /> Stop
                            </Button> */}
                        </div>
                    </Toolbar>
                </AppBar>

                <div style={styles.container}>
                    {/* Service info */}
                    <Table>
                        <TableBody>
                            <TableRow style={{ height: 10 }}>
                                <TableCell>
                                    <ProjectIcon fontSize="small" />
                                </TableCell>
                                <TableCell>Projekt:</TableCell>
                                <TableCell>{app.ProjektNr}</TableCell>
                                <TableCell />
                                <TableCell />
                                <TableCell />
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <PhoneIcon fontSize="small" />
                                </TableCell>
                                <TableCell>Telefon:</TableCell>
                                <TableCell>{app.ekTel1}</TableCell>
                                <TableCell>
                                    <CalendarIcon fontSize="small" />
                                </TableCell>
                                <TableCell>Start:</TableCell>
                                <TableCell>
                                    {app.StartDate !== null ? moment(app.StartDate).format(
                                        "DD.MM YYYY HH:mm"
                                    ): ""}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <PhoneIcon fontSize="small" />
                                </TableCell>
                                <TableCell>Mobil:</TableCell>
                                <TableCell>{app.ekTel2}</TableCell>
                                <TableCell>
                                    <CalendarIcon fontSize="small" />
                                </TableCell>
                                <TableCell>Ende:</TableCell>
                                <TableCell>
                                    {app.EndDate !== null ? moment(app.EndDate).format(
                                        "DD.MM YYYY HH:mm"
                                    ): ""}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <KommissionIcon fontSize="small" />
                                </TableCell>
                                <TableCell>Komission:</TableCell>
                                <TableCell>{app.ProjekteKomision}</TableCell>
                                <TableCell>
                                    <TimeIcon fontSize="small" />
                                </TableCell>
                                <TableCell>Geplante Dauer:</TableCell>
                                <TableCell>{app.GeplanteServicezeit + " min"}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <WorkIcon fontSize="small" />
                                </TableCell>
                                <TableCell>Auftraggeber:</TableCell>
                                <TableCell>{app.Firma}</TableCell>
                                <TableCell>
                                    <PersonIcon fontSize="small" />
                                </TableCell>
                                <TableCell>Bearbeiter:</TableCell>
                                <TableCell>{app.Berater}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <PersonIcon fontSize="small" />
                                </TableCell>
                                <TableCell>Kunde:</TableCell>
                                <TableCell>
                                    {app.ekName}, {app.Strasse}, {app.Plz}{" "}
                                    {app.Ort}
                                </TableCell>
                                <TableCell>
                                    <PhoneIcon fontSize="small" />
                                </TableCell>
                                <TableCell>Telefon:</TableCell>
                                <TableCell>{app.BeraterTel1}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell />
                                <TableCell />
                                <TableCell />
                                <TableCell>
                                    <PhoneIcon fontSize="small" />
                                </TableCell>
                                <TableCell>Mobil:</TableCell>
                                <TableCell>{app.BeraterTel2}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    <br />
                    {/* Mangelbeschreibung */}
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell style={{ fontSize: 14 }} colSpan={5}>
                                    Mangelbeschreibung
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Pos</TableCell>
                                <TableCell>Anzahl</TableCell>
                                <TableCell>Beschriebung</TableCell>
                                <TableCell>Notiz</TableCell>
                                {/* <TableCell>erledigt</TableCell> */}
                            </TableRow>
                            {this._returnDescriptionData(
                                app.ServiceMangelbeschreibung
                            ).map((item, index) => {
                                return (
                                    <React.Fragment key={item.id}>
                                        <TableRow
                                            style={{
                                                backgroundColor: "white"
                                            }}
                                        >
                                            <TableCell>
                                                {item.Position}
                                            </TableCell>
                                            <TableCell>{item.Anzahl}</TableCell>
                                            <TableCell>
                                                {item.Mangelbechreibung}
                                            </TableCell>
                                            <TableCell>{item.Notiz}</TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                );
                            })}
                        </TableBody>
                    </Table>

                    <br />
                    {/* Notiz */}
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell style={{ fontSize: 14 }} colSpan={4}>
                                    Notiz
                                </TableCell>
                            </TableRow>
                            {notes.map(item => {
                                const attachments = this.props.attachments.filter(
                                    c => c.NoteID === item.id
                                );
                                const attDom = attachments.map(item => {
                                    return (
                                        <span key={item.id}>
                                            <AttachmentIcon
                                                fontSize="small"
                                                onClick={() => {
                                                    this.openDocument(item);
                                                }}
                                            />
                                            {item.FileName}
                                            {item.Extension}
                                        </span>
                                    );
                                });
                                return (
                                    <React.Fragment key={item.id}>
                                        <TableRow>
                                          <TableCell  style={styles.tablecell}>
                                            <Scrollbars
                                                renderTrackHorizontal={props => <div {...props} className="track-horizontal" style={{display:"none"}}/>}
                                                autoHeight
                                                autoHeightMax={150}
                                                autoHide={false}
                                                >
                                               <p style={styles.notiz}>{item.Note ? item.Note : "-"}</p>
                                            </Scrollbars>
                                          </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <b>
                                                    <span
                                                        style={{
                                                            fontSize: ".8em"
                                                        }}
                                                    >
                                                        {item.MitarbeiterName}{" "}
                                                        {moment(
                                                            item.NoteDate
                                                        ).format(
                                                            "DD.MM YYYY HH:mm"
                                                        )}{" "}
                                                        {attDom}
                                                    </span>
                                                </b>
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                );
                            })}
                        </TableBody>
                    </Table>
                    <br />
                    {/* Form fields */}
                    {/* <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell style={{ border: 0 }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox disabled={app.Started === 0 || app.Started === undefined}
                                                checked={
                                                    this.props.app.Finished ===
                                                    1
                                                }
                                                onChange={this.handleChange}
                                                name="Finished"
                                                value="checkedB"
                                                color="primary"
                                            />
                                        }
                                        label="Arbeit abgeschlossen"
                                    />
                                </TableCell>
                            </TableRow>
                            {/* <TableRow />
                            <TableRow />

                        </TableBody>
                    </Table> */}

                    <br />

                    {/* Fotos */}
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell style={{ border: 0 }}>
                                    <GridList cellHeight={160} cols={3}>
                                        {fotos.map((tile, index) => (
                                            <GridListTile
                                                cols={1}
                                                key={index}
                                                style={{
                                                    border: "1px solid #DDD"
                                                }}
                                            >
                                                <img src={tile.data} alt="" />
                                                <GridListTileBar
                                                    actionIcon={
                                                        <IconButton>
                                                            <DeleteIcon
                                                                color="secondary"
                                                                onClick={() => {
                                                                    this.removeImage(
                                                                        tile.id
                                                                    );
                                                                }}
                                                            />
                                                        </IconButton>
                                                    }
                                                />
                                            </GridListTile>
                                        ))}
                                    </GridList>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>
                <TakePhoto
                    open={this.state.TakePhotoOpen}
                    handleClose={this.closeTakePhoto}
                    handleTakeScreenshot={this.handleTakeScreenshot}
                />
                <MessageBox
                    open={this.state._deleteImageMessageOpen}
                    Title="Foto Loeschen?"
                    MessageBox="Sind Sie Sicher?"
                    AcceptText="Loeschen"
                    CancelText="Abbrechen"
                    handleClose={this.handleCloseMessage}
                    handleAccept={this.onRemoveImage}
                />
                <Dialog fullScreen open={this.state.dialog}>
                    <AppBar>
                        <Toolbar>
                            <IconButton
                                color="inherit"
                                onClick={this.handleClose}
                                aria-label="Close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <div>
                                <div>Serviceauftrag Daten einfügen</div>
                            </div>
                        </Toolbar>
                    </AppBar>
                </Dialog>
                <StartWorkQuestionDialog open={this.state.questionDialogOpen} type={this.state.type} handleClose={this.handleCloseDialogs} toggleWorkAccepted={this.toggleWorkAccepted} />
            </Dialog>
        );
    }
}

TaskUnassigned.propTypes = {
    app: PropTypes.object.isRequired,
    notes: PropTypes.array.isRequired,
    attachments: PropTypes.array.isRequired,
    fotos: PropTypes.array.isRequired,
    setTitle: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    app: SelectedAppSelector(state),
    notes: SelectedAppNotesSelector(state),
    attachments: SelectedAppAttachmentsSelector(state),
    fotos: SelectedAppPhotosSelector(state)
});

//export default connect(mapStateToProps, { DoSync, ReportProgress })(TaskView);
export default withRouter(
    connect(
        mapStateToProps,
        {
            setTitle,
            SelectAppointmentByID,
            SetPropertyValue,
            SavePropertyValue,
            SaveData,
            FotoAdd,
            FotoRemove
        }
    )(TaskUnassigned)
);
